import IMAGES from "@/public/assets/img";


export const getMetadata = (locale) => {
    // Fallback to empty values if locale or SeoContent is not found to prevent TypeError
    const seoContent = locale?.SeoContent || {};
    return {
      title: seoContent.title || "",
      description: seoContent.description || "",
      keywords: seoContent.keyword || "",
      alternates: {
        canonical: seoContent.url || "",
      },
      icon: IMAGES?.SHARED?.favIcon?.src || "", // Assuming this is a global import
      openGraph: {
        images: seoContent.imagePath || "",
        title: seoContent.title || "",
        description: seoContent.description || "",
        url: seoContent.url || "",
      },
    };
  };